import React from 'react';
import PropTypes from 'prop-types';

const Button = (props) => {
    const { label, classes, bgColor, onClick, type } = props;

    return (
        <button type={type} style={{ backgroundColor: bgColor }} className={['button', classes && classes].join(' ')} onClick={onClick}>
            <span className="label-text">
                {label}
            </span>
        </button>
    )
};

Button.propTypes = {
    label: PropTypes.string,
    classes: PropTypes.string,
    bgColor: PropTypes.string,
    onClick: PropTypes.func,
    type: PropTypes.oneOf(['button', 'submit'])
};
  
Button.defaultProps = {
    label: '',
    onClick: () => {},
    classes: null,
    bgColor: '',
    type: 'button'
};

export default Button;
